"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatePasscodeResponseMapper = void 0;
var ValidatePasscodeResponseMapper = /** @class */ (function () {
    function ValidatePasscodeResponseMapper(data) {
        this.localData = data;
    }
    ValidatePasscodeResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return ValidatePasscodeResponseMapper;
}());
exports.ValidatePasscodeResponseMapper = ValidatePasscodeResponseMapper;
//# sourceMappingURL=ValidatePasscodeResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/mappers/ValidatePasscodeResponseMapper.js
// module id = 1499
// module chunks = 8